import moment from "moment";

// ✅ Add days (returns moment for UI compatibility)
export const addDaysinDate = (date, numberOfDays) =>
  date ? moment(date).add(numberOfDays, "days") : null;

// ✅ Add months (returns moment)
export const addMonthinDate = (date, numberOfMonths) =>
  date ? moment(date).add(numberOfMonths, "months") : null;

// ✅ Safe moment conversion (FIXED for FR issue)
export const momentDate = (date) => {
  if (!date) return null;

  // 🔥 Force parse using ISO format (prevents FR invalid date)
  return moment(date, ["YYYY-MM-DD", moment.ISO_8601], true);
};

// ✅ ONLY for API (string format)
export const getMySqlDate = (date) => {
  if (!date) return "";

  return moment(date).format("YYYY-MM-DD");
};

// ✅ Server date conversion
export const getServerDateToMySql = (date) => {
  if (!date) return "";

  return moment(date).format("YYYY-MM-DD HH:mm:ss");
};

// ✅ Add month range (FIXED)
// export const getMonthDateRange = (year, month) => {
//   const y = Number(year);

//   let m;

//   // ✅ CASE 1: month is number (0–11)
//   if (typeof month === "number") {
//     m = month; // already correct for moment
//   }

//   // ✅ CASE 2: month is string (EN/FR)
//   else {
//     const parsed = moment(month, ["MMMM", "MMM"], true);

//     if (parsed.isValid()) {
//       m = parsed.month(); // already 0–11
//     } else {
//       m = moment().month(); // fallback
//     }
//   }

//   const startDate = moment([y, m]).startOf("month");
//   const endDate = moment([y, m]).endOf("month");

//   return {
//     startDateOfMonth: startDate.isValid() ? startDate : null,
//     lastDateOfMonth: endDate.isValid() ? endDate : null,
//   };
// };

export const getMonthDateRange = (year, month) => {
  let y = Number(year);
  let m = Number(month);

  // ✅ fallback if invalid
  if (isNaN(y)) {
    y = moment().year();
  }

  if (isNaN(m) || m < 1 || m > 12) {
    m = moment().month() + 1; // current month
  }

  const startDate = moment()
    .year(y)
    .month(m - 1)
    .startOf("month");

  const endDate = moment(startDate).endOf("month");

  return {
    startDateOfMonth: startDate,
    lastDateOfMonth: endDate,
  };
};

export const dateInDetail = (date) => {
  const dateObj = moment(date || new Date());

  return {
    fullDate: date || "",
    date: dateObj.format("DD"),
    date_th: dateObj.format("Do"),
    month: dateObj.format("MM"),
    year: dateObj.format("YYYY"),
    day: dateObj.format("dddd"),
    shortDay: dateObj.format("ddd"),
    monthName: dateObj.format("MMMM"),
    shortMonthName: dateObj.format("MMM"),
    time: dateObj.format("hh:mm"),
    time24: dateObj.format("HH:mm"),
    meridiem: dateObj.format("a"),
    longDay: dateObj.format("dddd"),
    day_index: dateObj.day(),
  };
};

// ✅ Format short date
export const formatShortDate = (date) => {
  const dateObj = moment(date);
  return `${dateObj.format("Do")} ${dateObj.format("MMMM")}, ${dateObj.format(
    "ddd"
  )}`;
};

// ✅ Initial static date
export const getinitialdate = () => moment("01-01-2022", "DD-MM-YYYY");

// ✅ Kenyan time (FIXED - returns moment)
export const getKenyanDateTime = () => {
  const d = new Date();
  const utc = d.getTime() + d.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * 3);

  return moment(nd);
};

// ✅ Convert UTC → Kenya
export const convertUTCtoKenyaTime = (date) => {
  return moment(date).add(3, "hours");
};

// ✅ First / Last date of month
export const getFirstDate = (date) => moment(date).startOf("month");

export const getLastDate = (date) => moment(date).endOf("month");

// ✅ Date range check
export const isDateBetweenTwoDates = (compareDate, startDate, endDate) => {
  return moment(compareDate).isBetween(
    moment(startDate),
    moment(endDate),
    "days",
    "[]"
  );
};

// ✅ Time difference
export const differenceBetweenTwoTime = (startDate, endDate) => {
  const sDate = moment(startDate, "HH:mm");
  const eDate = moment(endDate, "HH:mm");

  return eDate.diff(sDate, "minutes");
};

// ✅ Convert minutes → HH:mm
export const generateHourMinutesFromMinutes = (mins) => {
  const hours = Math.floor(mins / 60);
  const minutes = mins - 60 * hours;

  return `${hours <= 9 ? "0" : ""}${hours}:${
    minutes <= 9 ? "0" : ""
  }${minutes}`;
};

// ✅ Date difference
export const differenceBetweenTwoDates = (startDate, endDate) => {
  return moment(startDate).diff(moment(endDate), "days");
};

// ✅ Number of days between
export const numberOfDaysBetweenDates = (start_date, end_date) => {
  return moment(end_date).diff(moment(start_date), "days");
};
